import Icon from 'veui/components/Icon'
import { IconQrcode } from 'dls-icons-vue'

Icon.register('qrcode', IconQrcode)
